<div class="new-reservation-dialog__resource-picker">
  <span
    class="new-reservation-dialog__resource-picker-origin"
    cdkOverlayOrigin
    #resourcePickerOverlayOrigin="cdkOverlayOrigin"
  >
    <cue-button
      data-cy="assist-new-reservation-add-location"
      btnClass="small"
      type="secondary"
      [icon]="icons.cueAdd"
      (click)="onAddLocation($event)"
      [smallResponsive]="true"
    >
      {{ translation.newReservationUi.location.addAnotherLocation | transloco }}
    </cue-button>
  </span>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="resourcePickerOverlayOrigin"
    [cdkConnectedOverlayOpen]="active()"
    [cdkConnectedOverlayPositions]="resourcePickerPositions"
    [cdkConnectedOverlayOffsetY]="8"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="12"
    (backdropClick)="closePicker.emit()"
    (detach)="closePicker.emit()"
  >
    <div class="new-reservation-dialog__resource-picker-panel">
      <input
        data-cy="assist-new-reservation-location-search"
        #resourcePickerSearchInputElement
        type="search"
        class="new-reservation-dialog__resource-picker-search"
        [value]="searchValue()"
        [placeholder]="translation.newReservationUi.location.resourceSearchPlaceholder | transloco"
        (input)="onResourcePickerFilterChange($any($event.target).value)"
      />

      @let pickerItems = items();

      <div
        class="new-reservation-dialog__resource-picker-list"
        role="listbox"
        (scroll)="onResourcePickerScroll($event)"
      >
        @if (loading() && pickerItems.length === 0) {
          <p class="new-reservation-dialog__resource-picker-empty">
            {{ translation.newReservationUi.location.resourcePickerLoading | transloco }}
          </p>
        } @else if (pickerItems.length === 0) {
          <p class="new-reservation-dialog__resource-picker-empty">
            {{ translation.newReservationUi.location.noResourcesFound | transloco }}
          </p>
        } @else {
          @for (item of pickerItems; track item.id) {
            <button
              [attr.data-cy]="'assist-new-reservation-location-option-' + item.id"
              type="button"
              class="new-reservation-dialog__resource-picker-item"
              role="option"
              (click)="resourceSelected.emit(item)"
            >
              <ng-template #pickerAvailabilityReasonsTemplate>
                <div class="new-reservation-dialog__tooltip-content">
                  @for (reason of item.availabilityReasons; track reason) {
                    <p>{{ reason }}</p>
                  }
                </div>
              </ng-template>

              <div class="new-reservation-dialog__resource-picker-item__container">
                <div class="new-reservation-dialog__resource-picker-item__name">
                  <span
                    class="new-reservation-dialog__availability-dot"
                    [class.new-reservation-dialog__availability-dot--loading]="item.availabilityState === 'loading'"
                    [class.new-reservation-dialog__availability-dot--available]="item.availabilityState === 'available'"
                    [class.new-reservation-dialog__availability-dot--warning]="item.availabilityState === 'warning'"
                    [class.new-reservation-dialog__availability-dot--error]="item.availabilityState === 'error'"
                    [class.new-reservation-dialog__availability-dot--unknown]="item.availabilityState === 'unknown'"
                    [attr.aria-label]="item.availabilityLabelKey | transloco"
                    [cueTooltip]="item.availabilityReasons.length > 0 ? pickerAvailabilityReasonsTemplate : undefined"
                    [cueTooltipCommonType]="'info'"
                  ></span>
                  <strong>{{ item.displayName }}</strong>
                </div>

                <span class="new-reservation-dialog__resource-picker-text">
                  <span>{{ item.detail }}</span>

                  <small class="availability">{{ item.availabilityLabelKey | transloco }}</small>
                </span>
              </div>
            </button>
          }
        }
      </div>
    </div>
  </ng-template>
</div>
